import { render, staticRenderFns } from "./securityInspectorDetail.vue?vue&type=template&id=14679f1d"
import script from "./securityInspectorDetail.vue?vue&type=script&lang=js"
export * from "./securityInspectorDetail.vue?vue&type=script&lang=js"
import style0 from "./securityInspectorDetail.vue?vue&type=style&index=0&id=14679f1d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports